var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.59,
    height: 17.563,
    viewBox: "0 0 17.59 17.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fill",
    d: "M16.364,13.512a5.452,5.452,0,0,1,1.226,2.256,1.832,1.832,0,0,1-3.665,0,5.948,5.948,0,0,1,1.24-2.249.733.733,0,0,1,1.2-.007Zm-.641-2.824L9.991,16.419a4.037,4.037,0,0,1-5.7,0l-3.11-3.11a4.031,4.031,0,0,1,0-5.7l2.8-2.8L1.788,2.62A1.1,1.1,0,1,1,3.343,1.065L5.534,3.256,6.912,1.877A1.1,1.1,0,0,1,8.473.332l8.8,8.8a1.1,1.1,0,0,1-1.546,1.561ZM14.167,9.135l-5.7-5.7L7.088,4.811l2.851,2.85A1.1,1.1,0,0,1,8.384,9.216L5.534,6.365l-2.8,2.8a1.832,1.832,0,0,0,0,2.592l3.11,3.11a1.832,1.832,0,0,0,2.592,0Z",
    transform: "translate(0 -0.037)",
    fill: "#c8102e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill);
export default __webpack_public_path__ + "static/media/fill.d0e7eae9d31d63567e19d4ecb2a7158e.svg";
export { ForwardRef as ReactComponent };